import { isPlainObject } from 'shared/utils/object';
import { SingleInspectionReportOnView } from './singleInspectionReportOnView';

export function isSingleInspectionReportOnView(
  values: unknown
): values is SingleInspectionReportOnView {
  if (!isPlainObject(values)) {
    return false;
  }

  return (
    'fieldsContent' in values &&
    'selectedFields' in values &&
    'templateSectionEnabled' in values &&
    'checklistSectionEnabled' in values &&
    'issueDataSectionEnabled' in values &&
    'inspectionInfo' in values &&
    'sectionDescriptions' in values &&
    'sectionAttachments' in values &&
    'controlledElementStandard' in values &&
    'controlledElementStandardAttachments' in values &&
    'generalStandardAttachments' in values &&
    'controlledElementAttachments' in values
  );
}
